import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import Button from 'components/DesignSystem/Button';
import type { IconType } from 'components/DesignSystem/Icon/icons';
import { cssVar } from 'constants/theme';

import './index.scss';

export default function EmptyState({
  icon,
  title,
  text,
  actionLabel,
  onAction,
}: {
  icon: IconType;
  title: string;
  text: string;
  actionLabel?: string;
  onAction?: () => void;
}) {
  return (
    <div className="agro-wbc-dv-mobile-empty-state">
      <Icon iconType={icon} color={cssVar('text-accent')} size="large" />
      <h2 className="agro-wbc-dv-mobile-empty-state-title">{title}</h2>
      <p className="agro-wbc-dv-mobile-empty-state-text">{text}</p>
      {actionLabel && onAction && (
        <Button onClick={onAction}>{actionLabel}</Button>
      )}
    </div>
  );
}
